import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id/index.ts';
import { Title, Wrapper } from './styled.js';
export const Item = memo(function Item({ id, title, active, setActiveId, dataTestId }) {
    const testId = useMemo(() => getDataTestId(dataTestId, active ? 'active' : 'inactive'), [active, dataTestId]);
    const handleClick = useCallbackRef(() => {
        setActiveId(id);
    });
    return (_jsx(Wrapper, { $active: active, onClick: handleClick, "data-testid": testId, children: _jsx(Title, { children: title }) }));
});
